<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/new/top-left.jpg" />
        </div>
        <el-menu
          :default-active="defaultActive"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <!-- <el-submenu index="/product">
            <template slot="title">产品中心</template>
            <el-menu-item index="/product1">电动汽车无线充电系统</el-menu-item>
            <el-menu-item index="/product2">综合能源服务平台</el-menu-item>
            <el-menu-item index="/product3">快速频率响应控制装置</el-menu-item>
            <el-menu-item index="/product4">无源传感器监测及故障诊断系统</el-menu-item>
            <el-menu-item index="/product5">发电厂辅机控制系统</el-menu-item>
          </el-submenu> -->
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/solve">解决方案</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>

      <div v-if="footer_show">
        <Footers></Footers>
      </div>
    </el-container>
  </div>
</template>

<script>
import Footers from './components/Footer.vue'

export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      footer_show:true
    };
  },
  components: {
    Footers
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  },
  watch: {
    $route(to, from) {
      if(this.$route.path === "/") {
        this.footer_show = false;
      } else {
        this.footer_show = true;
      }
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  height: 85px !important;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  width: 100%;
  margin: 0 auto;
  // background-image: url("./assets/img/new/top-bg.jpg");

  .logo {
    position: relative !important;
    margin-top: 10px;
    left: 0 !important;
    width: 731px;
    img {
      width: 60%;
      height: 70%;
    }
  }
}

.el-menu {
  background-color: transparent !important;
}

.el-menu--horizontal {
  border: solid 0px transparent !important;
  background: transparent !important;
  padding-right: 10%;
}

.el-submenu {
  align-content: center;
  padding: 10px 20px 10px 20px !important;
  background: transparent !important;
  font-size: 1rem !important;
  color: #555555 !important;
}

.el-menu-item {
  align-content: center;
  padding: 10px 20px 10px 20px !important;
  background: transparent !important;
  font-size: 1rem !important;
  color: #555555 !important;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
  align-content: center;
  // padding: 10px 20px 10px 20px !important;
  background: transparent !important;
  font-size: 1rem !important;
  color: #555555 !important;
}

.el-menu--horizontal>.el-submenu.is-active {
    border-bottom: 2px solid #409EFF !important;
    color: #409EFF !important;
    font-size: 1.2rem !important;
    font-weight: 600;
}



.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #409EFF !important;
    color: #409EFF !important;
    font-size: 1.2rem !important;
    font-weight: 600;
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: auto;
  // position: fixed;
  bottom: 0px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 40px;
    background: #125688;
    // background-image: url("./assets/img/new/foot.jpg");
    background-color: #14679f;
    align-content: center;
    span {
      color: #fff;
      padding-top: 10px;
      line-height: 30px;
      text-align: center;
      display: block;
      position: relative;
    }
  }
}
</style>
